module.exports = __webpack_public_path__ + "media/img/apple-icon-76x76-e24da6277f36895bd4909436ea53bafb.png";